import Procedure from "components/Procedure/Procedure";

const ProcedurePage = () => {
	return <Procedure />;
};

export default ProcedurePage;
